import { render, staticRenderFns } from "./AdyenTermsAndConditionsV2.vue?vue&type=template&id=e618fe1a&"
import script from "./AdyenTermsAndConditionsV2.vue?vue&type=script&lang=js&"
export * from "./AdyenTermsAndConditionsV2.vue?vue&type=script&lang=js&"
import style0 from "./AdyenTermsAndConditionsV2.vue?vue&type=style&index=0&id=e618fe1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports